/* eslint-disable import/prefer-default-export */
const sourceMapperLiveStream = {
  deeplink: 'Deeplink',
  banner: 'Banner',
  stream: 'Stream',
  livestream: 'Live Stream',
  research: 'Research Tab',
};

const sourceMapperEventsPage = {
  deeplink: 'Deeplink',
  research: 'Research Tab (Icon)',
};

export {
  sourceMapperLiveStream,
  sourceMapperEventsPage,
};
